import React from "react";

const JQuery_NoConflict = () => {
  return (
    <div>
      <h1>JQuery_NoConflict</h1>
      <p>Placeholder component for: "JQuery_NoConflict"</p>
    </div>
  );
};

export default JQuery_NoConflict;
